import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

  const UIMITPlan = {
    name: 'My Mitigation Plan',
    imageUrl: '../../images/MITPlan.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIMITCreate = {
    name: 'My Mitigation Plan',
    imageUrl: '../../images/MITCreate.png',
    imageSize: "100%",
    bradius: 20,
  };

const UIMITTargets = {
    name: 'My Mitigation Plan',
    imageUrl: '../../images/MITTargets.png',
    imageSize: "100%",
    bradius: 20,
  };

const UIMITSubplan = {
    name: 'Mitigation Sub-Plan',
    imageUrl: '../../images/MITSubplan.png',
    imageSize: "100%",
    bradius: 20,
  };

const UIMITCreatesub = {
    name: 'Mitigation Sub-Plan',
    imageUrl: '../../images/MITCreatesub.png',
    imageSize: "100%",
    bradius: 20,
  };


export const MITPlan = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>My Mitigation Plans </b><br/><br/>
      The purpose of the My Mitigation Plans section is to highlight exactly what mitigation plans 
      are assigned to you, what progress has been made, and to provide further details of any particular plan. <br/><br/>
      The filter on the top left gives you the ability to view plans by scan type.  <br/><br/>
      View individual plan details by clicking on the scan name. <br/><br/>
      The information shown includes when the mitigation plan was assigned, who it was assigned to, 
      its due date, and what progress has been made. You also have the ability to reassign plans. 
      Please note that this information may differ depending on the scan type. <br/><br/>
      In addition, a simplified display will appear for each of the targets within the scan, 
      detailing the target name, total CVE count, the number of CVEs categorized from critical 
      to low, and the root cause for the vulnerabilities. <br/><br/>
      Clicking on the View icon will display what work has been performed. <br/><br/>
      For any root causes that have had no progress made, click on the wrench icon to be presented 
      with a display that allows you to review and/or perform an action. <br/><br/>
      When scrolling down on this display, note each of the details in relation to the specific CVEs 
      that are being exposed by this vulnerability. <br/><br/>Depending on the action taken, select 
      the appropriate option from the drop-down. <br/><br/>
      Regardless of which action is selected, there is a requirement to provide key details of the 
      action specifics within the summary box. <br/><br/>
      Once an action summary has been entered, be sure to select which CVEs apply to this action 
      (ensuring a blue tick is assigned to the CVE) and click SUBMIT to update the action and mitigation plan status. 
      </div>
      <div style={helpimg}>
      <img
        src={UIMITPlan.imageUrl}
        alt={'Image of ' + UIMITPlan.name}
        style={{
          width: UIMITPlan.imageSize,
          borderRadius: UIMITPlan.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const MITCreate = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Create a Mitigation Plan</b><br/><br/>
      Select one of the three mitigation plan types. Mitigation plans are specifically 
      tailored to meet the risk reduction requirements based on the plan type. <br/><br/>
      Enter a meaningful plan name to refer to this plan later, and assign the plan to 
      the primary responsible individual. Also, choose the start and end (due) dates 
      using the available calendar widgets. A realistic due date metric is critical 
      because mitigation performance is measured against it. <br/><br/>
      Now use the scan selector to choose the scan the mitigation plan applies to. 
      Only dates that have scans are highlighted in the calendar and once a date is 
      selected, the dropdown shows scan names only for that date. 
      </div>
      <div style={helpimg}>
      <img
        src={UIMITCreate.imageUrl}
        alt={'Image of ' + UIMITCreate.name}
        style={{
          width: UIMITCreate.imageSize,
          borderRadius: UIMITCreate.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const MITTargets = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Select Target(s)</b><br/><br/>
      In the case of vulnerability mitigations, view the vulnerability breakdown by 
      target. Select any or all of the targets to be included in this plan. Separate 
      plans can be made for specific targets based on the organizational structure 
      and choice of assignee candidate to manage the plan duties. Once all fields 
      have been entered and the appropriate selections have been made, hit Submit 
      to enter and begin the Mitigation Plan. <br/><br/>
      The assignee will automatically receive an email that they have been assigned 
      to manage a plan. The email will prompt them to log in to the CYRISMA command 
      center to view the plan and begin work. <br/><br/>
      As plan actions are taken, progress against the plan will be reflected on the 
      Mitigation Dashboard, and detailed progress can be monitored within the plan 
      itself. <br/><br/>
      Mitigation plans can also be quickly created from the respective scan history 
      pages. Select the scan from the history list and jump directly to the Create 
      Mitigation page from here. This will pre-select the scan for which the plan 
      is to be created against. 
      </div>
      <div style={helpimg}>
      <img
        src={UIMITTargets.imageUrl}
        alt={'Image of ' + UIMITTargets.name}
        style={{
          width: UIMITTargets.imageSize,
          borderRadius: UIMITTargets.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const MITSubplan = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Sub-Mitigation Overview </b><br/><br/>
      Sub-Mitigation plans allow plans to be broken down into smaller segments where each 
      segment can be assigned to other individuals within a department, allowing increased 
      manpower to be applied against the completion effort. <br/><br/>
      Keep in mind that Sub-Mitigation plans can ONLY be created against Data Sensitivity 
      scans. This is because data sensitivity is file and email focused whereas Vulnerability 
      and Secure Baseline scans are target focused. For vulnerability and Secure baseline, 
      targets can be easily divided among multiple mitigation plans, so there is no need 
      for sub-mitigation plans. <br/><br/>
      In Data Sensitivity plans, the primary plan owner remains responsible for the 
      completion of the entire plan, has visibility into the progress of all sub-plans, 
      and can even contribute effort to the completion of sub-plans if desired. 
      </div>
      <div style={helpimg}>
      <img
        src={UIMITSubplan.imageUrl}
        alt={'Image of ' + UIMITSubplan.name}
        style={{
          width: UIMITSubplan.imageSize,
          borderRadius: UIMITSubplan.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const MITCreatesub = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Create a Sub-Mitigation Plan</b><br/><br/>
      To make a sub-mitigation plan, click one of the Mitigation Names from the Data 
      Sensitivity Plan list. Sub-mitigation plans can only be created against plans 
      belonging to a specific assignee. If the plan belongs to someone else, it must 
      be reassigned before it becomes visible in the plan list. <br/><br/>
      In the sub-mitigation plan creation form, enter a meaningful sub-plan name to 
      later refer to this plan by, and assign the plan to the primary responsible 
      individual. <b>ONLY individuals within the same department as the original plan 
      assignee are available from the drop-down selector!</b> Also, choose the assigned 
      begin date and a plan due date using the available calendar widgets. A realistic 
      due date metric is important as mitigation performance is measured off this date. <br/><br/>
      <b>NOTE:</b> A sub-mitigation plan cannot be created against a plan that is 
      already overdue! Also, dates for the sub-plan cannot be selected if they are 
      outside the date range of the original Mitigation Plan. <br/><br/>
      In the Bottom Section, use the folder browser to select the files or folders that 
      are to be assigned to this sub-plan. The primary plan assignee can still see the 
      entire folder/file set in the original plan, while the sub-plan assignee can only 
      see files and folders assigned specifically to this sub-plan. <br/><br/>
      Submit when the fields have been filled in and the appropriate file selections 
      have been made. <br/><br/>
      The assignee will automatically receive an email stating that they have been 
      assigned mitigation activity. The email will prompt them to log in to the CYRISMA 
      command center to view the plan and begin work. <br/><br/>
      As plan actions are taken against a plan and all of its sub-plans, progress against 
      the plan will be reflected on the Mitigation Dashboard and detailed progress can 
      be monitored within the plan itself. <br/><br/>
      Mitigation sub-plans can also be quickly created from the respective primary 
      Data Sensitivity plan page. Select a plan from the history list of assigned 
      plans and jump directly to create Sub Plan from here. This will pre-select the 
      plan for which the sub-plan is to be created against. The sub-plan’s name, 
      assignee, start/end dates, and selected files must still be provided.
      </div>
      <div style={helpimg}>
      <img
        src={UIMITCreatesub.imageUrl}
        alt={'Image of ' + UIMITCreatesub.name}
        style={{
          width: UIMITCreatesub.imageSize,
          borderRadius: UIMITCreatesub.bradius,
        }}
      />
      </div>
    </div>
  );
};
